import axios from "axios";
import { refreshTokenURL } from "./constants/apiEndPoints";
import publicAxios from "./publicAxios";

const privateAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true
});

export const migrationAxios = axios.create({
  baseURL: process.env.REACT_APP_MIGRATION_API_URL,
  withCredentials: true
});

privateAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 403 &&
      !originalRequest._retry &&
      error.response.data.message ===
        "Failed to extract username from JWT token"
    ) {
      originalRequest._retry = true;
      try {
        await publicAxios.post(refreshTokenURL);
        return privateAxios(originalRequest);
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default privateAxios;
